import type { SxProps, Theme } from '@mui/material';
import type { CSSProperties } from 'react';

export const styles = {
    card: { mt: 10, p: 5 } as SxProps<Theme>,
    icon: { margin: 10 } as CSSProperties,
    btn: {
        m: 2,
        borderRadius: '100px',
        padding: '8px 40px',
        fontFamily: ['Source Sans Pro', 'sans-serif'].join(','),
        fontWeight: 600,
        fontSize: '14px',
    } as SxProps<Theme>,
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    } as SxProps<Theme>,
};
